<template>
    <b-card header-tag="header" class="m-3" no-body>
        <template #header>
            <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                Perdas de Qualificação OSCIP
                <b-button size="sm" class="float-right m-1" to="/contratacao/nova-perda-de-qualificacao-oscip">
                    <font-awesome-icon icon="plus" class="mr-3" />
                    Nova Perda de Qualificação OSCIP
                </b-button>
            </h6>
        </template>
        <b-card-body>
            <card-filtros-busca>
                <b-form @submit.prevent="pesquisarOscip" @reset.prevent="limparFiltros" v-if="showFilters">
                    <b-row>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="CNPJ">
                                <b-form-input id="input-filtros-cnpj" v-model="filtros.cnpj">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="Nome da Entidade">
                                <b-form-input id="input-filtros-nome-entidade" v-model="filtros.nomeEntidade">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="Tipo do Documento">
                                <b-form-input id="input-filtros-tipo-documento" v-model="filtros.tipoDocumento">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3" class="pt-4">
                            <b-button type="submit" class="float-right">
                                <font-awesome-icon icon="search" class="mr-3" />Filtrar
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="Cidade">
                                <b-form-input id="input-filtros-cidade" v-model="filtros.cidade">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="UF">
                                <b-form-input id="input-filtros-uf" v-model="filtros.uf">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3">
                            <b-form-group id="input-group-type" label-size="md" label="Situação">
                                <b-form-select id="select-filtros-situacao" v-model="filtros.ativo" :options="comboAtivo">
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3" lg="3" class="pt-4">
                            <b-button type="reset" class="float-right" variant="outline-secondary">
                                <font-awesome-icon icon="redo" class="mr-3" />Limpar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </card-filtros-busca>
            <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
                striped stacked="xl" per-page="0" :current-page="currentPage" show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(actions)="row">
                    <div class="actions-icons lgvert">
                        <b-link class="text-dark" @click="detalhesPerdaDeQualificacao(row)">
                            <font-awesome-icon icon="eye" />
                            <div style="font-size: 12px">Detalhes</div>
                        </b-link>
                        <b-link class="text-dark" @click="editarPerdaDeQualificacao(row)">
                            <font-awesome-icon icon="edit" />
                            <div style="font-size: 12px">Editar</div>
                        </b-link>
                        <b-link class="text-dark" @click="perguntarAlternarStatus(row)">
                            <font-awesome-icon icon="ban" />
                            <div style="font-size: 12px">{{ row.item.FlAtivo ? 'Desativar' : 'Ativar' }}</div>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <table-pagination v-if="totalRows" :total-rows="totalRows" per-page="10" @pageChange="novaPaginaOscip">
            </table-pagination>
        </b-card-body>
    </b-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import oscipService from "@/services/contratacao/oscipService"
import { store } from "@/store";
import { FiltrosOscip } from '@/types/contratacao/filtros-oscip'
import { TableField } from '@/types/table-field'
import { Oscip } from '@/types/contratacao/oscip'
import { fieldsOscip } from '@/types/contratacao/fields-oscip'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'

const CompProps = Vue.extend({
    name: 'PerdasDeQualificacaoOscip',
    components: { CardFiltrosBusca, TablePagination },
})

@Component
export default class PerdasDeQualificacaoOscip extends CompProps {
    filtros: FiltrosOscip = new FiltrosOscip()
    fields: TableField[] = fieldsOscip
    items: Oscip[] = []
    showFilters = true
    tableBusy = false
    totalRows = 0

    currentPage = 1

    comboAtivo = [
        { text: 'SELECIONE', value: '', disabled: true },
        { text: 'Ativo', value: 'true' },
        { text: 'Inativo', value: 'false' },
    ]

    async mounted() {
        try {
            store.blockScreen = true
            this.filtros.limpar()
            await this.pesquisarOscip()
        } finally {
            store.blockScreen = false
        }
    }

    novaPaginaOscip(page): void {
        this.currentPage = page
        this.pesquisarOscip()
    }

    async pesquisarOscip(): Promise<void> {
        this.tableBusy = true
        try {
            const response = await oscipService.pesquisarOscip(this.filtros, this.currentPage);
            if (response && response.status === 200) {
                this.items = response.data.perdasQualificacao.map((pr: any) => {
                    const retorno = Object.assign(new Oscip(), pr)
                    retorno.tratarDadosDaAPI()
                    return retorno
                })
                this.totalRows = response.data.totalRows
            } else {
                throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
            }
        } catch (e: any) {
            console.error(e)
            this.items = []
            this.totalRows = 0
            this.$toast.error(e.message ? e.message : e);
        } finally {
            this.tableBusy = false
        }
    }

    async detalhesPerdaDeQualificacao(row) {
        this.$router.push('/contratacao/detalhes-perda-de-qualificacao-oscip/' + row.item.IdPerdaQualificacao)
    }

    async editarPerdaDeQualificacao(row) {
        this.$router.push('/contratacao/editar-perda-de-qualificacao-oscip/' + row.item.IdPerdaQualificacao)
    }

    async perguntarAlternarStatus(row) {
        this.$bvModal.msgBoxConfirm('Deseja mudar a situação deste item?', {
            buttonSize: 'sm',
            cancelTitle: 'Cancelar',
            cancelVariant: 'outline-secondary',
            centered: true,
            headerBgVariant: 'secondary',
            headerTextVariant: 'light',
            okTitle: 'Mudar',
            title: 'Confirmar mudança de situação',
        }).then(value => {
            if (value) this.alternarStatus(row.item.IdPerdaQualificacao)
        }).catch(err => {
            console.error('Erro ao mudar situação', err)
        })
    }

    async alternarStatus(idPerdaQualificacao): Promise<void> {
        try {
            const response = await oscipService.toggleStatus(idPerdaQualificacao)
            if (response && response.status == 200) {
                this.$toast.success('Situação modificada com sucesso');
                //this.$router.push("/contratacao/perdas-de-qualificacao-oscip");
                this.pesquisarOscip()
            } else {
                this.$toast.error(
                    response.data.msg || "Erro ao modificar a situação."
                );
            }
        } catch (e: any) {
            console.error("Erro ao modificar a situação", e);
            if (e instanceof Error) {
                this.$toast.error(e.message);
            } else {
                this.$toast.error("Erro ao modificar a situação.");
            }
        }
    }



    limparFiltros(): void {
        this.filtros.limpar()
        this.showFilters = false
        this.$nextTick(() => {
            this.showFilters = true
        })
    }
}
</script>

<style></style>